 <div *ngIf="params?.data?.isActive == true && !params?.genrateBillNo"  class="mt-1">
<ng-container *ngIf="!params?.isStatus"> 
<div *ngIf="params?.data?.isActive == true"  class="mt-1"> 
    <app-button class="d-flex justify-content-center px-2"  [customClass]="'success buttonSize cursor-pointer'" [buttonLabel]="'Active'"></app-button>
</div> 
<div *ngIf="params?.data?.isActive == false && !params?.genrateBillNo" class="mt-2">
    <app-button  [customClass]="'danger buttonSize cursor-pointer'" class="d-flex justify-content-center px-2" [buttonLabel]="'Deactive'"></app-button>
</div>

<div *ngIf="params?.genrateBillNo && !params?.data?.billSeries" class="mt-2">
    <app-button class="d-flex justify-content-center px-2" [customClass]="'text-primary border-light-primary cursor-pointer bg-white'" (click)="onButtonClicked(params)" [buttonLabel]="'Genrate Bill No'"></app-button>
</div>
</ng-container>
</div>


<ng-container *ngIf="params?.data?.status">

  <div *ngIf="params?.data?.status === 'Delivered'" class="my-1 px-2">
    <app-button [customClass]="'success buttonSize cursor-pointer d-flex justify-content-center px-2'" [buttonLabel]="params?.data?.status"></app-button>
  </div>
    <div *ngIf="params?.data?.status === 'Undelivered'" class="my-1 px-2">
    <app-button [customClass]="'danger buttonSize cursor-pointer d-flex justify-content-center px-2'" [buttonLabel]="params?.data?.status"></app-button>
  </div>
  <!-- <div *ngIf="params?.data?.status === 'APPROVED'" class="mt-2">
    <app-button [customClass]="'success buttonSize cursor-pointer'" [buttonLabel]="params?.data?.status"></app-button>
  </div>
  <div *ngIf="params?.data?.status === 'REJECTED'" class="mt-2">
    <app-button [customClass]="'danger buttonSize cursor-pointer'" [buttonLabel]="params?.data?.status"></app-button>
  </div>
  <div *ngIf="params?.data?.status === 'PENDING'" class="mt-2">
    <app-button [customClass]="'pending buttonSize cursor-pointer'" [buttonLabel]="params?.data?.status"></app-button>
  </div>
  <div *ngIf="params?.data?.statusId === 1" class="mt-2">
    <app-button [customClass]="'success buttonSize cursor-pointer'" (click)="onStatusIconClick(params)"
      [buttonLabel]="params?.data?.status"></app-button>
  </div>
  <div *ngIf="params?.data?.statusId === 0" class="mt-2">
    <app-button [customClass]="'danger buttonSize cursor-pointer'" (click)="onStatusIconClick(params)"
      [buttonLabel]="params?.data?.status"></app-button>
  </div> -->
</ng-container>

<ng-container *ngIf="params?.IsextendSubscription" class="align-items-center d-flex justify-content-center"> 

  <!-- BUTTON VIEW -->
  <div *ngIf="isbtnshow" class="mt-1 d-flex justify-content-center">
    <app-button  
      [customClass]="'danger cursor-pointer extend-btn '"
      (click)="onExtendSubscription()"
      [buttonLabel]="'Extend Subscription'">
    </app-button>
  </div>

  <!-- DATE PICKER + SAVE + CANCEL -->
  <div *ngIf="!isbtnshow" class=" gap-3 custom-margin">

    <!-- Date Picker -->
  <div class="d-flex justify-content-center align-items-center ">
  <input 
    type="date" 
    class="date-picker"
    placeholder="MM-dd-yyyy"
    [(ngModel)]="selectedDate"
    (input)="selectedDate = $event.target.value"> 
</div>


    <!-- Save Icon -->
   <div
  class="d-flex align-items-center text-primary justify-content-center"
  (click)="isValidDate() && onSave()"
  [class.disabled]="!isValidDate()"
>
  <img src="assets/fonts/feather/save.svg" class="savebtn"
       [ngClass]="{ 'cursor-pointer': isValidDate() }"
       alt="save icon">
</div>
   
    <!-- Cancel Icon -->
    <div class="cursor-pointer d-flex align-items-center cancelbtn " (click)="onCancel()">
      <svg id="cancel" xmlns="http://www.w3.org/2000/svg" 
           width="12.5" height="12.5" viewBox="0 0 10 10" color>
        <path id="Path_35106"
          d="M5.552,5,9.885.668A.391.391,0,0,0,9.333.115L5,4.448.667.115A.391.391,0,0,0,.114.668L4.447,5,.114,9.334a.391.391,0,0,0,.552.552L5,5.553,9.333,9.886a.391.391,0,0,0,.552-.552Z"
          fill="red">
        </path>
      </svg>
    </div>

  </div>

</ng-container>
